/** Side gutter for tab content in the buyers modal, whose body is rendered edge to edge. */
export const BUYERS_MODAL_GUTTER_CLASS = 'px-12';

/** The same gutter as a margin, for a single element such as the form's error alert. */
export const BUYERS_MODAL_GUTTER_MARGIN_CLASS = 'mx-12';

/** Vertical stack of buyer-details sections. */
export const BUYERS_MODAL_SECTION_GROUP_CLASS = 'flex flex-col gap-5.25';

/** The buyer-details form: gutter groups around a full-width roster. */
export const BUYERS_MODAL_FORM_CLASS = `${BUYERS_MODAL_SECTION_GROUP_CLASS} py-4`;
